export default __webpack_public_path__ + "static/media/h5-product-banner.42fd532f.png";